// extracted by mini-css-extract-plugin
export var errorsContainer = "_rz-1";
export var link = "_rz-0";